module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAmwAAAACCAYAAADl9IAmAAAAJ0lEQVRYhe3OQQEAIAgEMKR/xcuCDfzKY0uwk2QKAIC1+ncAAIC3C7ZzA5r3lbjAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/left_title.png
// module id = dLYX
// module chunks = 1